<template>
  <div class="sino-card my-active-list" v-loading.fullscreen.lock="loading">
    <!-- 头部筛选 -->
    <top-part :rightPart="true">
      <template slot="difinePort">
        <van-dropdown-menu
          active-color="#29BEBC"
          :overlay="false"
          class="my-active-list1"
        >
          <van-dropdown-item
            v-model="currentStatue"
            :options="statueList"
            @change="onFilter()"
          />
        </van-dropdown-menu>
        <van-dropdown-menu
          active-color="#29BEBC"
          :overlay="false"
          class="my-active-list2"
        >
          <van-dropdown-item
            v-model="currentType"
            :options="typeList"
            @change="onFilter()"
          />
        </van-dropdown-menu>
      </template>
    </top-part>
    <div style="height: 1.173333rem"></div>
    <!-- 头部筛选 -->

    <div>
      <div v-if="activeityList.length">
        <div
          :class="
            item2.activityThumbnail
              ? 'my-active-card'
              : 'card-box my-card-margin'
          "
          v-for="item2 in activeityList"
          :key="item2.welfareId"
          @click="openActivity(item2)"
        >
          <!-- 新数据 （活动列表、活动奖品） -->
          <template v-if="item2.activityThumbnail">
            <div class="my-active-img">
              <span :style="{ background: btnBackFn(item2.status) }">{{
                statueObj[item2.status] || ""
              }}</span>
              <img :src="item2.activityThumbnail" />
            </div>
            <div class="my-active-content">
              <div class="my-active-title">
                <img src="@/images/hd.png" />
                <div>{{ item2.name || item2.activityName }}</div>
              </div>
              <div class="my-active-text">
                <div>活动时间：{{ item2.startTime }}至{{ item2.endTime }}</div>
                <span>{{ typeObj[item2.type] || "" }}</span>
              </div>
            </div>
          </template>
          <!-- 新数据 （活动列表、活动奖品） -->

          <!-- 老数据 -->
          <template v-else>
            <!-- 老数据 （活动列表） -->
            <template v-if="activeTab == 0">
              <div class="card-title">
                <img src="@/images/hd.png" alt srcset />
                <span>{{ item2.name }}</span>
              </div>
              <div class="card-content">
                <div class="content-text" v-html="item2.content"></div>
                <div class="content-date">
                  {{ item2.startTime }} ~ {{ item2.endTime }}
                </div>
              </div>
              <div class="card-footer">
                查看详情
                <i class="cubeic-arrow"></i>
                <span v-if="item2.type == 2" class="acti-type">报名活动</span>
                <span
                  v-else-if="item2.type == 1"
                  class="acti-type"
                  style="color: #4f87fb"
                  >打卡活动</span
                >
                <span v-else class="acti-type" style="color: #4f87fb"
                  >线上活动</span
                >
              </div>
            </template>
            <!-- 老数据 （活动奖品） -->
            <template v-else>
              <div class="card-title">
                <img src="@/images/fl-red.png" alt srcset />
                <span>{{ item2.activityName }}</span>
              </div>
              <div class="card-content">
                <div class="content-text" v-html="item2.content"></div>
                <div class="content-date">领取时间：{{ item2.startTime }}</div>
              </div>
              <div class="card-footer">
                查看详情
                <i class="cubeic-arrow"></i>
              </div>
            </template>
          </template>
          <!-- 老数据 -->
        </div>
      </div>
      <!-- 没数据时 -->
      <div class="blank" v-if="!activeityList.length && !loading">
        <img src="@/images/404-02.png" alt />
      </div>
    </div>

    <!-- <van-tabs v-model="activeTab"  sticky @click='tabClick'>
      <van-tab v-for="item in tabList" :title="item.label" :key='item.key'>
        
      </van-tab>
    </van-tabs> -->
  </div>
</template>
<script type="text/ecmascript-6">
import { getAppActivityList,getSignGroup,getUserInformation,delCookie } from "@/common/api";
import Vue from "vue";
import { toast } from "@/common/api/api.js";
import topPart from "../../components/topPart";
import activityConfig from '../../centralControl/utils/activityConfig'
export default {
  components: {
    topPart
  },
  data() {
    return {
      activeityList: [],
      loading: true,
      activeTab: 0,
      typeList: activityConfig.typeList,
      statueList:activityConfig.statueList,
      tabList:[
        {label:'活动列表',key:'1',list:null},
        {label:'活动奖品',key:'2',list:null},
      ],
      currentType: "",
      currentStatue: "",
      typeObj:activityConfig.typeObj,
      statueObj:activityConfig.statueObj,
      currentBaseInfo: JSON.parse(localStorage.getItem("loginInfo"))
    };
  },
  created() {
    this.getActivityList();//活动列表
    let id = JSON.parse(window.localStorage.getItem("loginInfo")).id || "";
      getUserInformation({
        id: id
      }).then(res => {
        if (res.code == 200) {
          if (!res.data.status) {
            this.$createDialog({
              type: "alert",
              title: "提示",
              content: "登录失效,请重新登录",
              icon: "cubeic-alert",
              confirmBtn: {
                text: "退出",
                active: true,
                href: "javascript:;"
              },
              onConfirm: () => {
                window.localStorage.clear();
                delCookie("sessionId");
                this.$router.push("/login");
                window.location.reload();
              }
            }).show();
          }
        }
      });
  },
  methods: {
    //按钮颜色
    btnBackFn(statue){
      let colorObj=activityConfig.colorObj
      return colorObj[statue];
    },
    // 点击头部删选
    onFilter() {
      this.getActivityList();//活动列表
    },
    // 活动列表
    async getActivityList() {
      try {
        this.loading = true;
      const {currentType,currentStatue}=this;
      let params={
        type:currentType,
        status:currentStatue,
        currentPage:1,
        pageSize:500,
      }
     const res = await getAppActivityList(params)
        if (res.code == 200) {
          res.data.forEach(item => {
            item.content = item.content
              .replace(new RegExp("&lt;", "g"), "<")
              .replace(new RegExp("&quot;", "g"), "")
              .replace(new RegExp("&gt;", "g"), ">");
          });
          // this.tabList[0].list=res.data;
          // console.log(this.tabList)
          this.activeityList = res.data;
        } else {
          toast(this, res.message, "error");
        }
      } catch (error) {
        toast(this, error.message, "error");
      }finally{
        this.loading = false;
      }


    },

    openActivity(item) {
      console.log(this.activeTab, item);

      //  this.openActivityDetail(item);

      if (item.type == 1) {
        getSignGroup({
          id:item.id
        }).then(res=>{
          if(res.code == 200){
            if(res.data.length <= 1){
              this.$router.push({
                path:'/directActivity',
                query:{
                  id:item.id,
                  status:item.status,
                  signGroupId:item.signGroupId|| ''
                }
              })
            }else{
              this.$router.replace({
                path:"/activityType",
                query:{
                  id:item.id,
                  status:item.status
                }
              })
            }
          }
        })
      } else if(item.type==2){
        this.$router.push({
          path: "/signupActivity",
          query: {
            id: item.id,
            status: item.status
          }
        });
      } else {
        // 跳转线上活动
        this.$router.push({
          path: "/onLineActivity",
          query: {
            id: item.id,
            status: item.status
          }
        });
      }
    },
    // 打开活动奖品
    openActivityDetail(option){
      this.$router.push({
        path: "/activityDetail",
        query: {
          activityId: option.activityId,
          source: "me1",
          status:option.status,
          level:option.creatorOfficeLevel,
        }
      });
    }
  },
  beforeRouteLeave(to, from, next) {
    // debugger
    if (to.name === "personnelManagement") {
      next({ name: "personalCenter" });
    } else {
      next();
    }
  }
};
</script>
<style lang="stylus" type="stylesheet/stylus">
@import '../../assets/stylus/common.styl';
@import '../../assets/stylus/theme.styl';
.my-active-list {
  .van-tab--active {
    color: #38C6C3;
  }
  .van-dropdown-menu__bar {
    box-shadow:none;
  }
  .van-sticky {
    position:fixed;
    width: 100%;
    top: 45px;
    left: 0;
    z-index: 1;
  }
  .van-dropdown-item__option {
    text-align: center;
  }

  .van-cell__value {
    display: none;
  }
  .van-dropdown-menu__bar {
    height: 44px;
  }
}
  .my-active-list1{
    .van-popup--top{
      width: 36% !important;
      left:22% !important;
    }
  }
 .my-active-list2{
    .van-popup--top{
      left:62% !important;
      width: 36% !important;
    }
  }
  .my-card-margin {
    margin-top:10px !important;
  }
  .acti-type {
    padding:3px 5px;
    background: rgba(233, 244, 244, 1);
    float: right;
    font-weight: bold;
    height: 18px;
    line-height: 18px;
    margin-top: 0.16rem;
    color: rgba(56, 199, 196, 1);
    font-size:11px;
  }

  .my-active-card {
    background: #FFF;
    margin: 15px 15px 0 15px;
    border-radius: 10px;
    box-shadow:0px 1px 12px 0px rgba(212,217,226,1);
    .my-active-img {
      position: relative;
      img {
        width: 100%;
        height: 120px;
        border-radius: 10px 10px 0 0;
      }
      span {
        activityStatueBtn();
        position: absolute;
        left: 10px;
        top: 10px;
      }
    }
    .my-active-content {
      padding: 14px;
      >div {
        display: flex;
        align-items: center;
      }
      .my-active-title {
        img {
           width: 18px;
           margin-right: 4px;
        }
        div {
          font-size:16px;
          font-family:PingFang SC;
          font-weight:bold;
          color:$text-black;
        }
      }
      .my-active-text {
        justify-content: space-between;
        margin-top: 4px;
        div {
          font-size:12px;
          font-family:PingFang SC;
          font-weight:500;
          color:$text-gray2;
        }
        span {
          width:75px;
          height:20px;
          border:1px solid $main-bgColor;
          border-radius:19px;
          font-size:13px;
          font-family:PingFang SC;
          font-weight:bold;
          color:$main-bgColor;
          text-align: center;
          line-height: 20px;
        }
      }
    }
  }
</style>
